import * as yup from 'yup';

import { ObjectTypeBase } from '../../types/baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../../types/properties/Property';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import createShapeFromProperties from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  name: {
    type: 'String',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  type: {
    type: 'String',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  uri: {
    type: 'String',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
};

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use LinkType from application-types instead.
 */
export class LinkType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  name = 'Link';

  friendlyName = 'Link';

  get example() {
    return 'https://activate.vts.com/';
  }

  get default(): any {
    return {
      _id: null,
      name: null,
      type: null,
      uri: null,
    };
  }

  buildSchema() {
    return yup.object().shape(createShapeFromProperties(properties)).nullable();
  }

  properties = properties;
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Link from application-types instead.
 */
const definition = new LinkType();

Types.addBaseType(definition);
export default definition;
